const strokeStyles = ["#E6194B", "#4363D8", "#3CB44B"];

export function getFieldStroke(fieldIndex: number): string {
  return strokeStyles[fieldIndex % strokeStyles.length];
}
